import { render } from "./BaseTableCustomSortHeader.vue?vue&type=template&id=049c3b2f"
import script from "./BaseTableCustomSortHeader.vue?vue&type=script&lang=js"
export * from "./BaseTableCustomSortHeader.vue?vue&type=script&lang=js"

import "./BaseTableCustomSortHeader.vue?vue&type=style&index=0&id=049c3b2f&lang=css"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/helpers/BaseTableCustomSortHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "049c3b2f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('049c3b2f', __exports__)) {
    console.log('reload')
    api.reload('049c3b2f', __exports__)
  }
  
  module.hot.accept("./BaseTableCustomSortHeader.vue?vue&type=template&id=049c3b2f", () => {
    console.log('re-render')
    api.rerender('049c3b2f', render)
  })

}


export default __exports__